import posthogSDK from 'posthog-js';
import type { User } from '~/types/user';

export class PostHog {
  posthog: typeof posthogSDK;

  constructor(user?: User) {
    const { $config } = useNuxtApp();

    this.posthog = posthogSDK.init($config.public.posthogPublicKey, {
      custom_campaign_params: ['utm_app'],
      disable_session_recording: user?.role === 'guest',
    });
  }

  page(pageName: string, properties: Record<string, any> = {}) {
    this.posthog.capture('$pageview', {
      pageName,
      ...properties,
    });
  }

  track(eventName: string, properties: Record<string, any> = {}) {
    this.posthog.capture(eventName, properties);
  }

  identify(user: User, locale: string) {
    if (!user) return;

    const workspace = user.workspace || {};

    this.posthog.group(
      'company',
      user.tenant_id,
      {
        name: workspace.name,
        cohort: workspace.cohort,
        plan: workspace.plan,
      },
    );

    this.posthog.identify(user.id, {
      email: user.username,
      locale,
      role: user.role,
      tenantId: user.tenant_id,
      username: user.username,
    });
  }
}
